import React from "react"
import {
  describeReturnableContainers,
  formatDepositAmount,
  returnableContainersDeposit
} from "../../services/ReturnableContainers"

export class ProductUnitDeposit extends React.Component {
  constructor(props) {
    super(props)
  }

  // A unit has either its own deposit or returnable containers (crates, jars, etc.) that each
  // carry a deposit, never both.
  returnableContainers() {
    return this.props.product_unit.returnable_containers || []
  }

  depositAmount() {
    const returnableContainers = this.returnableContainers()
    if (returnableContainers.length == 0) { return Number(this.props.product_unit.deposit) }

    return returnableContainersDeposit(returnableContainers)
  }

  render() {
    const depositAmount = this.depositAmount()
    if (depositAmount == 0) { return '' }
    const returnableContainers = this.returnableContainers()
    return (
      <div className='deposit text-muted mt-2'>
        <span className='fa fa-recycle mr-1'></span>
        { '+' }
        <span className='tabular-nums'>{ formatDepositAmount(depositAmount) }</span>
        { returnableContainers.length > 0
          ? ` (${ describeReturnableContainers(returnableContainers) })`
          : ' refundable deposit' }
      </div>
    )
  }
}
